/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_LessonsInputs */

const en_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessons`)
};

const es_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecciones`)
};

const de_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterricht`)
};

const zh_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程`)
};

const ar_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدروس`)
};

const fr_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leçons`)
};

const vi_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài học`)
};

const sw_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masomo`)
};

const th_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียน`)
};

const bs_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcije`)
};

const ja_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスン`)
};

const ko_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨`)
};

const pt_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas`)
};

const it_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni`)
};

const sv_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektioner`)
};

const nl_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessen`)
};

const da_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektioner`)
};

const nb_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer`)
};

const fi_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppitunnit`)
};

const pl_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcje`)
};

const ru_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уроки`)
};

const tr_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dersler`)
};

const hi_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ`)
};

const id_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les`)
};

const ms_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran`)
};

const cs_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekce`)
};

const el_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μαθήματα`)
};

const he_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורים`)
};

const af_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesse`)
};

const hu_footer_link_lessons = /** @type {(inputs: Footer_Link_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Órák`)
};

/**
* | output |
* | --- |
* | "Lessons" |
*
* @param {Footer_Link_LessonsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_link_lessons = /** @type {((inputs?: Footer_Link_LessonsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_LessonsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_lessons(inputs)
	if (locale === "de") return de_footer_link_lessons(inputs)
	if (locale === "zh") return zh_footer_link_lessons(inputs)
	if (locale === "ar") return ar_footer_link_lessons(inputs)
	if (locale === "fr") return fr_footer_link_lessons(inputs)
	if (locale === "vi") return vi_footer_link_lessons(inputs)
	if (locale === "sw") return sw_footer_link_lessons(inputs)
	if (locale === "th") return th_footer_link_lessons(inputs)
	if (locale === "bs") return bs_footer_link_lessons(inputs)
	if (locale === "ja") return ja_footer_link_lessons(inputs)
	if (locale === "ko") return ko_footer_link_lessons(inputs)
	if (locale === "pt") return pt_footer_link_lessons(inputs)
	if (locale === "it") return it_footer_link_lessons(inputs)
	if (locale === "sv") return sv_footer_link_lessons(inputs)
	if (locale === "nl") return nl_footer_link_lessons(inputs)
	if (locale === "da") return da_footer_link_lessons(inputs)
	if (locale === "nb") return nb_footer_link_lessons(inputs)
	if (locale === "fi") return fi_footer_link_lessons(inputs)
	if (locale === "pl") return pl_footer_link_lessons(inputs)
	if (locale === "ru") return ru_footer_link_lessons(inputs)
	if (locale === "tr") return tr_footer_link_lessons(inputs)
	if (locale === "hi") return hi_footer_link_lessons(inputs)
	if (locale === "id") return id_footer_link_lessons(inputs)
	if (locale === "ms") return ms_footer_link_lessons(inputs)
	if (locale === "cs") return cs_footer_link_lessons(inputs)
	if (locale === "el") return el_footer_link_lessons(inputs)
	if (locale === "he") return he_footer_link_lessons(inputs)
	if (locale === "af") return af_footer_link_lessons(inputs)
	if (locale === "hu") return hu_footer_link_lessons(inputs)
	return en_footer_link_lessons(inputs)
});